import { Component, OnChanges, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { EmailsService } from '../../api/services/emails.service';
import { EmailTemplate } from '../../api/models/email-template';
import { CreateEmailTemplateRequest } from '../../api/models/create-email-template-request';
import { UpdateEmailTemplateRequest } from '../../api/models/update-email-template-request';

@Component({
  selector: 'app-email-template-page',
  templateUrl: './email-template-page.component.html',
  styleUrls: ['./email-template-page.component.scss']
})
export class EmailTemplatePageComponent implements OnInit, OnChanges {

  public template: EmailTemplate | null = null;
  public form: UntypedFormGroup;
  public isNew = false;

  constructor(
    private emailsService: EmailsService,
    private builder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.form = this.builder.group({
      name: ['', Validators.required],
      description: [''],
      subject: [''],
      message: ['']
    });
  }

  public cancel(): void {
    this.router.navigate(['/settings/templates']);
  }

  public saveTemplate(): void {
    const formValues = this.form.value;

    if (this.isNew) {
      const request: CreateEmailTemplateRequest = {
        name: formValues.name,
        description: formValues.description || null,
        subject: formValues.subject || null,
        message: formValues.message || null,
      };
      this.emailsService.createEmailTemplate({ body: request }).subscribe((saved) => {
        this.template = saved;
        this.isNew = false;
        this.ngOnChanges();
        this.router.navigate(['/settings/templates/email', saved.id]);
      });
    } else if (this.template) {
      const request: UpdateEmailTemplateRequest = {
        name: formValues.name,
        description: formValues.description || null,
        subject: formValues.subject || null,
        message: formValues.message || null,
      };
      this.emailsService.updateEmailTemplate({
        templateId: this.template.id,
        body: request
      }).subscribe((saved) => {
        this.template = saved;
        this.ngOnChanges();
      });
    }
  }

  public ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      if (params.has('templateId')) {
        const templateId = +params.get('templateId')!;
        this.emailsService.listEmailTemplates().subscribe((templates) => {
          this.template = templates.find(t => t.id === templateId) || null;
          this.ngOnChanges();
        });
      } else {
        this.template = { id: 0, name: '', description: null, subject: null, message: null };
        this.isNew = true;
        this.ngOnChanges();
      }
    });
  }

  public ngOnChanges(): void {
    if (this.template) {
      this.form.reset();
      this.form.patchValue({
        name: this.template.name,
        description: this.template.description || '',
        subject: this.template.subject || '',
        message: this.template.message || '',
      });
    }
  }
}
